import Head from "next/head";
import React from "react";
import { IHtmlHeaderDataFromApi } from "./HtmlHeader.interface";

export const HtmlHeader = ({
    title,
    favicon,
    seoPreview,
    children,
}: {
    title: string;
    favicon?: string;
    seoPreview?: IHtmlHeaderDataFromApi;
    children?: JSX.Element | JSX.Element[];
}) => {
    return (
        <Head>
            <title>{title}</title>
            <meta property="og:title" content={seoPreview?.title || "Exly"} />
            <meta property="og:type" content="website" />
            {seoPreview?.description && (
                <meta
                    property="og:description"
                    content={seoPreview.description}
                />
            )}
            <link rel="icon" type="image/png" href={favicon} />
            {/* calling this with component syntax inside HEAD does not make it appear in the DOM as
            title, meta or any other elements (e.g. script) need to be 
            contained as direct children of the Head element, or wrapped into maximum one 
            level of <React.Fragment> or arrays—otherwise the tags won't 
            be correctly picked up on client-side navigations. */}
            {children}
        </Head>
    );
};

HtmlHeader.defaultProps = {
    favicon: undefined,
    seoPreview: {},
    children: <></>,
};
